import React, { useEffect, useState } from 'react';
import { ColumnProps } from 'antd/lib/table';

import {
  AwsInstanceCostRecord,
  AwsInstanceCostRecords,
} from '@totem/components/administration/amazonWebServices/types';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';
import { getToken } from '@totem/components/userContext/accountUtilities';
import { AWS_INSTANCES_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  instanceId: string;
};

const InstanceCostTable = ({ instanceId }: Props) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<AwsInstanceCostRecords>([]);
  const [pageSize, setPageSize] = useState<number>(10);

  useEffect(() => {
    setLoading(true);

    fetch(`${AWS_INSTANCES_ENDPOINT}/${instanceId}/cost`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((records: AwsInstanceCostRecords) => setData(records ?? []))
      .finally(() => setLoading(false));
  }, [instanceId]);

  const columns: ColumnProps<AwsInstanceCostRecord>[] = [
    {
      title: 'Period Start',
      key: 'periodStart',
      sorter: (left, right) =>
        left.item.period.start.localeCompare(right.item.period.start),
      defaultSortOrder: 'descend',
      render: (_, record) => <span>{record.item.period.start}</span>,
    },
    {
      title: 'Period End',
      key: 'periodEnd',
      render: (_, record) => <span>{record.item.period.end}</span>,
    },
    {
      title: 'Amount',
      key: 'amount',
      render: (_, record) => (
        <span>
          {record.item.amount.amount} {record.item.amount.unit}
        </span>
      ),
    },
  ];

  return (
    <IBTable
      rowKey={(record) => record.id}
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={{
        pageSize,
        showSizeChanger: true,
        onShowSizeChange: (_, size) => setPageSize(size),
      }}
    />
  );
};

export default InstanceCostTable;
